export const sxScrollWrapper = {
  height: '100%',

  '.simplebar-content': {
    minHeight: '100%',
  },
};
